import navbar from './Modules/navbar';

const loaderNavbar = {
  load: async (client) => {
    return navbar.getNavbar(client);
  }
}

export default loaderNavbar;
